import { appInsights } from "../services/telemetry";

export function logMessage(
    message: string, 
    severity: 'info' | 'warn' | 'error' = 'info',
    properties?: { [key: string]: any }
) {
  if (appInsights && appInsights.core && appInsights.core.isInitialized) {
    appInsights.trackTrace({
      message,
      severityLevel: severity === 'info' ? 1 : severity === 'warn' ? 2 : 3,
      properties
    });
  } else {
    console[severity] ? console[severity](message) : console.log(message);
  }
}